import { DatesHelpers, NumericHelpers } from "@core/helpers";
import { BILLING_SESSIONS_INVOICE_STATUS } from "@core/constants";
import { BillingSessionCustomerModel } from "./billing-session-customer.model";

export const IBillingSessionInvoice = Object.freeze({
  hours: "nb_hours",
  excludingTaxAmount: "amount_ht",
  includingTaxAmount: "amount_ttc",
  statusCode: "status",
  payment: "payment",
  customer: "user",
  paymentType: "type",
  paymentDate: "date",
  invoiceNumber: "invoice_number",
});

export class BillingSessionPaymentModel {
  constructor(data = {}) {
    this[IBillingSessionInvoice.paymentType] = data[IBillingSessionInvoice.paymentType];
    this[IBillingSessionInvoice.paymentDate] = data[IBillingSessionInvoice.paymentDate];
  }

  getDate() {
    return DatesHelpers.getFormattedDate(this[IBillingSessionInvoice.paymentDate]);
  }

  getType() {
    return this[IBillingSessionInvoice.paymentType];
  }
}

export class BillingSessionInvoiceModel {
  constructor(data = {}) {
    this[IBillingSessionInvoice.invoiceNumber] = data[IBillingSessionInvoice.invoiceNumber];
    this[IBillingSessionInvoice.hours] = data[IBillingSessionInvoice.hours];
    this[IBillingSessionInvoice.excludingTaxAmount] = data[IBillingSessionInvoice.excludingTaxAmount];
    this[IBillingSessionInvoice.includingTaxAmount] = data[IBillingSessionInvoice.includingTaxAmount];
    this[IBillingSessionInvoice.statusCode] = data[IBillingSessionInvoice.statusCode];
    this[IBillingSessionInvoice.payment] = data[IBillingSessionInvoice.payment];
    this[IBillingSessionInvoice.customer] = data[IBillingSessionInvoice.customer];
  }

  getHours() {
    return this[IBillingSessionInvoice.hours];
  }

  getExcludingTaxAmount() {
    return NumericHelpers.formatNumberAsCurrency({ number: this[IBillingSessionInvoice.excludingTaxAmount], forceTrailingZeros: true });
  }

  getIncludingTaxAmount() {
    return NumericHelpers.formatNumberAsCurrency({ number: this[IBillingSessionInvoice.includingTaxAmount], forceTrailingZeros: true });
  }

  getStatus() {
    return Object.values(BILLING_SESSIONS_INVOICE_STATUS).find((status) => status.code === this[IBillingSessionInvoice.statusCode]);
  }

  getPayment() {
    return new BillingSessionPaymentModel(this[IBillingSessionInvoice.payment]);
  }

  getCustomer() {
    return new BillingSessionCustomerModel(this[IBillingSessionInvoice.customer]);
  }

  getCustomerName() {
    return this.getCustomer().getCompany() || this.getCustomer().getFullname();
  }

  getInvoiceNumber() {
    return this[IBillingSessionInvoice.invoiceNumber];
  }

  hasInvoice() {
    return this.getInvoiceNumber() !== undefined;
  }
}
